/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum UOM {
  Femtoliters = 'Femtoliters',

  Grams_g = 'Grams_g',

  Micrograms_mcg = 'Micrograms_mcg',

  Microliters_mcL = 'Microliters_mcL',

  Milliequivalents_mEq = 'Milliequivalents_mEq',

  Milligrams_mg = 'Milligrams_mg',

  Milliliters_mL = 'Milliliters_mL',

  Millimeters_mm = 'Millimeters_mm',

  Millimoles_mmol = 'Millimoles_mmol',

  Nanomoles_nmol = 'Nanomoles_nmol',

  Picograms_pg = 'Picograms_pg',
}
